module.exports = __webpack_public_path__ + "img/79.10b11e21.jpg";